export const TITLE="Merkmale";